import * as React from "react";
const ListIcon = (props: any) => (
  <svg
    width="current"
    height="current"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1319_27210"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <rect width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1319_27210)">
      <path
        d="M15.2 19C14.76 19 14.3833 18.8477 14.07 18.5431C13.7567 18.2384 13.6 17.8722 13.6 17.4444V14.3333C13.6 13.9056 13.7567 13.5394 14.07 13.2347C14.3833 12.9301 14.76 12.7778 15.2 12.7778H18.4C18.84 12.7778 19.2167 12.9301 19.53 13.2347C19.8433 13.5394 20 13.9056 20 14.3333V17.4444C20 17.8722 19.8433 18.2384 19.53 18.5431C19.2167 18.8477 18.84 19 18.4 19H15.2ZM15.2 17.4444H18.4V14.3333H15.2V17.4444ZM4 16.6667V15.1111H11.2V16.6667H4ZM15.2 11.2222C14.76 11.2222 14.3833 11.0699 14.07 10.7653C13.7567 10.4606 13.6 10.0944 13.6 9.66667V6.55556C13.6 6.12778 13.7567 5.76157 14.07 5.45694C14.3833 5.15231 14.76 5 15.2 5H18.4C18.84 5 19.2167 5.15231 19.53 5.45694C19.8433 5.76157 20 6.12778 20 6.55556V9.66667C20 10.0944 19.8433 10.4606 19.53 10.7653C19.2167 11.0699 18.84 11.2222 18.4 11.2222H15.2ZM15.2 9.66667H18.4V6.55556H15.2V9.66667ZM4 8.88889V7.33333H11.2V8.88889H4Z"
        fill="current"
      />
    </g>
  </svg>
);
export default ListIcon;
